import {Constants} from "@/constant/Constants";
import {SelectData} from "@/data/SelectData";
import { IntegrationType } from '@/types';

export class Integration extends SelectData{
    private _operators: string[];
    private _operator: string;
    private _brands: Array<string>;
    brand: string;

    constructor(data: IntegrationType) {
        super();
        this._name = data[Constants.NAME];
        this._id = data[Constants.ID];
        this._operators = data[Constants.OPERATORS];
        this._operator = this._operators[0];
        this._brands = data[Constants.BRANDS]
        this.brand = this._brands[0];
    }

    get operators(): string[] {
        return this._operators;
    }

    get brands(): Array<string> {
        return this._brands;
    }

    get operator(): string {
        return this._operator;
    }

    set operator(value: string) {
        this._operator = value;
    }
}
